export interface PatientNameParts {
  salutation?: string | null;
  name?: string | null;
}

export const formatPatientName = (patient?: PatientNameParts | null, fallback = "-") => {
  const parts = [patient?.salutation, patient?.name]
    .map((part) => (part || "").trim())
    .filter(Boolean);

  return parts.length ? parts.join(" ") : fallback;
};
